import React from "react"
import styled from "styled-components"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import { Link } from "gatsby"
import breakpoints from "../../styles/breakpoints"
import { withTranslation } from "gatsby-plugin-react-i18next"

const PageBreadcrumb = styled.div`
  ${fonts.helveticaNeueLight};
  color: ${props => props.dark ? colors.black : colors.grey};
  font-size: 12px;
  letter-spacing: 0;
  line-height: 22px;
  padding-top: 14px;
  padding-left: ${props => props.noPadding ? '0' : '33px'};
  a {
    color: ${props => props.dark ? colors.black : colors.grey};
    text-decoration: none;
  }
  li {
    display: inline-block;
  }
  li:not(:first-child):before {
    color: ${props => props.plp ? colors.black : colors.grey};
    content: "/";
    padding-left: 5px;
    padding-right: 5px;
  }
  @media(min-width: ${breakpoints.md}) {
    padding-left: ${props => props.noPadding ? '0' : '81px'};
    padding-top: ${props => props.plp ? "28px" : "15px"};
  }
`;

const Breadcrumbs = ({links, current, className, noPadding, t, plp}) => {
  return (
    <PageBreadcrumb className={className} noPadding={noPadding} plp={plp}>
      <nav aria-label="breadcrumb">
        <ol>
          <li>
            <Link to="/">
              {t('breadcrumbs.home')}
            </Link>
          </li>
          {links && links.map((link) => {
            return (
              <li key={link.path}>
                <Link to={link.path}>
                  {link.label}
                </Link>
              </li>
            )
          })}
          <li aria-current="page">
            {current}
          </li>
        </ol>
      </nav>
    </PageBreadcrumb>
  );
};

export default withTranslation()(Breadcrumbs);
